import { render } from "./EventsListItem.vue?vue&type=template&id=3e5c57f8&scoped=true"
import script from "./EventsListItem.vue?vue&type=script&lang=js"
export * from "./EventsListItem.vue?vue&type=script&lang=js"

import "./EventsListItem.vue?vue&type=style&index=0&id=3e5c57f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5c57f8"]])

export default __exports__